<script>
import ratingGood from '@/assets/images/icons/rating-good.svg?inline'
import ratingNormal from '@/assets/images/icons/rating-normal.svg?inline'
import ratingBad from '@/assets/images/icons/rating-bad.svg?inline'

export default {
  name: 'order-feedback',
  components: {
    ratingGood,
    ratingNormal,
    ratingBad
  },
  computed: {
    rating: {
      get() {
        return this.feedback.form.rating
      },
      set(rating) {
        this.$store.commit('order/setFeedbackForm', {
          rating
        })
      }
    },
    comment: {
      get() {
        return this.feedback.form.comment
      },
      set(comment) {
        const duplicateSpaces = /\s{2,}/g

        this.$store.commit('order/setFeedbackForm', {
          comment: comment.trim().replace(duplicateSpaces, ' ')
        })
      }
    },
    feedback() {
      return this.$store.getters['order/getFeedback']
    }
  },
  methods: {
    sendFeedback() {
      this.$store.commit('order/setFeedbackFields', {
        isLoading: true
      })

      this.$store.dispatch('order/sendFeedback', {
        id: this.$store.getters['order/getOrderInfo'].id,
        form: this.$store.getters['order/getFeedback'].form,
      })
    },
    updateFeedback() {
      this.$store.commit('order/setFeedbackFields', {
        isLoading: true
      })

      this.$store.dispatch('order/editFeedback', {
        id: this.$store.getters['order/getOrderInfo'].id,
        form: this.$store.getters['order/getFeedback'].form,
      })
    },
    editFeedbackForm() {
      this.$store.commit('order/setFeedbackFields', {
        showEditForm: true
      })
    },
    feedbackCommentFormatter(comment) {
      return comment && comment.length > 60
        ? `${comment.substr(0, 60)} ...`
        : comment
    }
  }
}
</script>

<template>
  <div class="order-sidebar__content order-feedback">
    <div
      v-if="feedback.showForm || feedback.showEditForm"
      class="order-feedback__form"
    >
      <h2 class="order-title">
        Оцените работу менеджера
      </h2>
      <div class="order-feedback__rate">
        <b-radio
          v-model="rating"
          :native-value="1"
        >
          <b-tooltip
            label="Плохо"
            position="is-bottom"
            animated
          >
            <rating-bad
              class="order-feedback__rate-icon order-feedback__rate-icon--bad"
              :class="{
                'order-feedback__rate-icon--bad-active': rating === 1
              }"
            />
          </b-tooltip>
        </b-radio>
        <b-radio
          v-model="rating"
          :native-value="3"
        >
          <b-tooltip
            label="Нормально"
            position="is-bottom"
            animated
          >
            <rating-normal
              class="order-feedback__rate-icon order-feedback__rate-icon--normal"
              :class="{
                'order-feedback__rate-icon--normal-active': rating === 3
              }"
            />
          </b-tooltip>
        </b-radio>
        <b-radio
          v-model="rating"
          :native-value="5"
        >
          <b-tooltip
            label="Отлично"
            position="is-bottom"
            animated
          >
            <rating-good
              class="order-feedback__rate-icon order-feedback__rate-icon--good"
              :class="{
                'order-feedback__rate-icon--good-active': rating === 5
              }"
            />
          </b-tooltip>
        </b-radio>
      </div>
      <div
        class="order-feedback__comment"
      >
        <b-field
          label="Комментарий"
        >
          <b-input
            v-model="comment"
            :custom-class="comment !== null ? 'active' : null"
            type="textarea"
            :maxlength="600"
          />
        </b-field>
      </div>
      <b-tooltip
        :label="!rating ? 'Необходимо поставить оценку' : null"
        position="is-bottom"
        class="order-feedback__action-tooltip"
        :class="{'order-feedback__action-tooltip--hidden': rating}"
        animated
      >
        <button
          v-if="feedback.showForm"
          class="
            rex-button
            rex-button--full-width
            rex-button--filled
            rex-button--filled-red
          "
          :class="{ 'rex-button--disabled': !rating }"
          @click="sendFeedback"
        >
          Отправить
        </button>
        <button
          v-if="feedback.showEditForm"
          class="
            rex-button
            rex-button--full-width
            rex-button--filled
            rex-button--filled-red
          "
          :class="{ 'rex-button--disabled': !rating }"
          @click="updateFeedback"
        >
          Сохранить
        </button>
      </b-tooltip>
    </div>
    <b-loading
      :is-full-page="false"
      :active.sync="feedback.isLoading"
    />
    <div
      v-if="feedback.isSended && feedback.showSendingMessage"
      class="order-feedback__response-message"
    >
      Спасибо за отзыв!
    </div>
    <div
      v-if="feedback.isSended && feedback.showEditMessage"
      class="order-feedback__response-message"
    >
      Отзыв успешно обновлен!
    </div>
    <div
      v-if="!feedback.showForm && !feedback.showEditForm"
      class="order-feedback__existing-rate"
    >
      <h2 class="order__title">
        Отзыв
      </h2>
      <div class="order-feedback__existing-rate-wrap">
        <rating-good
          v-if="feedback.form.rating === 5"
        />
        <rating-normal
          v-else-if="feedback.form.rating === 3"
        />
        <rating-bad
          v-else
        />
        <p class="order-feedback__existing-rate-text">
          {{ feedbackCommentFormatter(feedback.form.comment) }}
        </p>
      </div>
      <a
        href="javascript:;"
        class="order-feedback__existing-rate-action"
        @click="editFeedbackForm"
      >
        Изменить или дополнить
      </a>
    </div>
  </div>
</template>
